import { IGetAllHabilidadeUseCase } from "../../../presentation/useCases/read/get_all_habilidade_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { Habilidade } from "../../models/habilidade";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllHabilidadeUseCase
 */

export class GetAllHabilidadeUseCase extends BasePaginatedUseCase<Habilidade> implements IGetAllHabilidadeUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getAllHabilidade(
    tipoPesquisa: number,
    valueField: string,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllHabilidade(
      tipoPesquisa,
      valueField,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
